import type { Country, CountryISO } from 'commons/constants/countries'
import { authorizedCountryList } from 'commons/constants/countries'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export const sanitize = (s: string) => s.replace(/\D/g, '')

export const formatDisplay = (digits: string, c: CountryISO): string => {
	if (!digits) return ''
	const phone = parsePhoneNumberFromString(digits, c)
	return phone ? phone.formatNational() : digits
}

export const findCountryWithPhone = (phone: string): Country => {
	const country = authorizedCountryList.find((c) => c.phone === phone)
	if (!country) throw new Error(`Country not found for phone: ${phone}`)
	return country
}
